import { FormField, FormItemLabel } from "@portal/components/form";
import { FormCurrencyComponent, FormYesNoComponent } from "@portal/components/form/fieldLayouts";
import { FormNAICSCodeSelect } from "@portal/components/form/fields";
import { useFormContext, useWatch } from "react-hook-form";
import { type AccountFormValues } from "../../schema";
import { useShowContractHistoryQuestions } from "./useShowContractHistoryQuestions";

export const HistoryStep = () => {
	const formMethods = useFormContext<AccountFormValues>();
	const { control } = formMethods;
	const modelSize = useWatch({ control, name: "account.modelSize" }) as string;
	const isMediumOrLarge = modelSize === "medium" || modelSize === "large";
	const showContractHistoryQuestions = useShowContractHistoryQuestions();

	return (
		<div className="flex flex-col pt-[18px] pb-[125px] min-h-fit space-y-[50px]">
			<FormField>
				<FormItemLabel name="account.naicsCodes">
					What type of work do the companies in this account specialize in?
				</FormItemLabel>
				<FormNAICSCodeSelect
					name="account.naicsCodes"
					control={control}
					selectText="Select specialties"
					editText="Edit Specialties"
					title="Select Account Specialties"
					searchPlaceholder="Search specialties..."
				/>
			</FormField>
			{showContractHistoryQuestions && (
				<>
					<FormCurrencyComponent
						formMethods={formMethods}
						name="account.history.largestProjectCompleted"
						label="What is the value of the largest project completed by the companies in this account?"
						inputClassName="max-w-[300px]"
						testId="largest-project-completed"
					/>
					<FormYesNoComponent
						formMethods={formMethods}
						name="account.history.failedToCompleteAProject"
						label="Has any company in this account ever failed to complete a project?"
						deselectable
						testId="failed-to-complete-a-project"
					/>
					<FormYesNoComponent
						formMethods={formMethods}
						name="account.history.lostAPaymentSuit"
						label="Has any company in this account ever lost a payment suit?"
						deselectable
						testId="lost-a-payment-suit"
					/>
				</>
			)}
			<FormYesNoComponent
				formMethods={formMethods}
				name="account.history.causedSuretyLoss"
				label="Has any company in this account ever caused a loss to a surety?"
				deselectable
				testId="caused-surety-loss"
			/>
			{showContractHistoryQuestions && isMediumOrLarge && (
				<>
					<FormYesNoComponent
						formMethods={formMethods}
						name="account.history.constructionProjectsGrossLossGt10PercentLast36Months"
						label="In the past 3 years, has any company in this account experienced a gross loss on any project greater than 10% of that project's contract value?"
						tooltip="For example, a gross loss of at least $10,000 on a $100,000 project"
						deselectable
						testId="gross-loss-gt-10-percent"
					/>
					<FormYesNoComponent
						formMethods={formMethods}
						name="account.history.currentConstructionProjectExpectedGrossLoss"
						label="Does any company in this account expect a gross loss on a project they are currently working on?"
						deselectable
						testId="current-project-expected-gross-loss"
					/>
				</>
			)}
		</div>
	);
};
